import { TranslateService } from '@ngx-translate/core';

export class Constants {
    constructor(private translate: TranslateService) { }

    static readonly DASHBOARD_CELL_TAB = 0;
    static readonly DASHBOARD_FLOW_TAB = 1;

    // Device Types
    static readonly DEVICE_HOMEGATEWAY_DRIVERCODENAME = 'HomeGateway';
    static readonly DEVICE_GAS_DRIVERCODENAME = 'RedyGasMeter';

    // Error Codes
    static readonly TOO_MANY_LOGINS = 'VW-4A';
    static readonly INVALID_USER_PASS = 'invalid_grant';

    // VarStats Keys
    static readonly CURRENT_DAY = 'CurrentDay';
    static readonly CURRENT_MONTH = 'CurrentMonth';
    static readonly LAST_12_MONTHS = 'Last12Months';
    static readonly LAST_24_HOURS = 'Last24Hours';
    static readonly LAST_30_DAYS = 'Last30Days';
    static readonly CURRENT_MONTH_PREDICTION = 'CurrentMonthPrediction';

    // Module Types
    static readonly AC_MODULE = 'Re:dy A/C plug';
    static readonly PLUG_MODULE = 'Re:dy plug';
    static readonly SOLAR_PLUG_MODULE = 'Re:dy solar plug';
    static readonly METER_CIRCUIT_MODULE = 'Re:dy meter circuit';
    static readonly METER_SWITCH_MODULE = 'Re:dy meter switch';
    static readonly UNKOWN_MODULE = 'Equipamento Desconhecido';


    // Units
    static readonly UNIT_EURO = 'EUR';
    static readonly UNIT_KILOWATT_HOUR = 'kWh';
    static readonly UNIT_KILOWATT = 'kW';

    static readonly UNIT_EURO_VALUE = '€';
    static readonly UNIT_KILOWATT_HOUR_VALUE = Constants.UNIT_KILOWATT_HOUR;
    static readonly UNIT_KILOWATT_VALUE = 'kVA';

    // User Messages Type
    static readonly MESSAGE_INFO = 0;
    static readonly MESSAGE_WARNING = 1;
    static readonly MESSAGE_ALERT = 2;

    // QueryReadings egration Times
    static readonly MONTH_DAYS_EGRATION_PERIOD = 86400;
    static readonly DAY_HOURS_EGRATION_PERIOD = 3600;
    static readonly DAY_LANDSCAPE_HOURS_EGRATION_PERIOD = 900;
    static readonly YEAR_MONTHS_EGRATION_PERIOD = 1;
    static readonly YEARS_EGRATION_PERIOD = 12;

    static readonly MONTH_EGRATION_PERIOD_TYPE = 1;
    static readonly SECONDS_EGRATION_PERIOD_TYPE = 0;


    // Data Energy Variables
    static readonly ACTIVE_ENERGY_PRODUCED_DATA = 'EP.DEVICES.ActiveEnergyProduced';
    static readonly ACTIVE_ENERGY_CONSUMED_DATA = 'EC.DEVICES.ActiveEnergyConsumed';
    static readonly ACTIVE_SELF_ENERGY_CONSUMED_DATA = 'EC.DEVICES.SelfEnergyConsumed';
    static readonly ACTIVE_SELF_ENERGY_PRODUCED_DATA = 'EC.DEVICES.SelfEnergyProduced';
    static readonly ACTIVE_PEAK_POWER_CONSUMED_DATA = 'EC.DEVICES.ActivePeakPowerConsumed';


    // Module Functions
    static readonly HA_CONSUMPTION_METER = 'HA_CONSUMPTION_METER';
    static readonly HA_ENERGY_METER = 'HA_ENERGY_METER';
    static readonly HA_SWITCH = 'HA_SWITCH';
    static readonly HA_POWER_METER = 'HA_POWER_METER';
    static readonly HA_SMART_ENERGY_METER = 'HA_SMART_ENERGY_METER';
    static readonly HA_STANDBY = 'HA_STANDBY';
    static readonly HA_HVAC = 'HA_HVAC';
    static readonly HA_THERMOSTAT = 'HA_THERMOSTAT';
    static readonly VW_WIRELESS = 'VW_WIRELESS';
    static readonly EC_SELF_CONSUMPTION_METER = 'EC_SELF_CONSUMPTION_METER';
    static readonly HA_PRODUCTION_METER = 'HA_PRODUCTION_METER';
    static readonly ENERGY_STORAGE = 'ENERGY_STORAGE';
    static readonly HS_DETECTOR = 'HS_DETECTOR';
    static readonly HS_MOTION = 'HS_MOTION';
    static readonly HS_DOOR_WINDOW = 'HS_DOOR_WINDOW';
    static readonly HS_FLOOD = 'HS_FLOOD';
    static readonly HS_SMOKE = 'HS_SMOKE';
    static readonly HA_CLIMATE_METER = 'HA_CLIMATE_METER';
    static readonly HA_TEMPERATURE_METER = 'HA_TEMPERATURE_METER';

    // Module StateVar Keys
    static readonly RELAY_STATE_KEY = 'RelayState';
    static readonly TOTAL_ACTIVE_ENERGY_KEY = 'TotalActiveEnergy';
    static readonly ACTIVE_POWER_KEY = 'ActivePower';
    static readonly ACTIVE_POWER__PRODUCED_KEY = 'ActivePowerProduced';
    static readonly LOCKED_KEY = 'Locked';
    static readonly TOTAL_SELF_POWER_CONSUMPTION = 'TotalSelfPowerConsumption';
    static readonly TOTAL_REAL_POWER_CONSUMPTION = 'TotalRealPowerConsumption';
    static readonly HVAC_FAN_SPEED = 'FanSpeed';
    static readonly HVAC_HORIZONTAL_SWING_MODE = 'HorizontalSwing';
    static readonly HVAC_VERTICAL_SWING_MODE = 'VerticalSwing';
    static readonly HVAC_OPERATION_MODE = 'OperationMode';
    static readonly HVAC_PRESET_TEMP = 'PresetTemp';
    static readonly LAST_DETECTION_END = 'LastDetectionEnd';
    static readonly IS_DETECTING = 'IsDetecting';
    static readonly TEMPERATURE = 'Temperature';
    static readonly LOW_BATTERY = 'LowBattery';

    // HVAC Operation Modes
    static readonly OPERATION_MODE_COOL = 'COOL';
    static readonly OPERATION_MODE_HEAT = 'HEAT';
    static readonly OPERATION_MODE_DRY = 'DRY';
    static readonly OPERATION_MODE_FAN = 'FAN';
    static readonly OPERATION_MODE_OFF = 'OFF';

    // HVAC Horizontal Swing Model
    static readonly SWING_H_LEFT = 'LEFT';
    static readonly SWING_H_RIGHT = 'RIGHT';
    static readonly SWING_H_CENTER = 'CENTER';

    // HVAC Vertical Swing Model
    static readonly SWING_V_VERT = 'VERT';
    static readonly SWING_V_MED = 'MED';
    static readonly SWING_V_HOR = 'HOR';

    // HVAC Fan Speeds
    static readonly FAN_SPEED_AUTO = 'AUTO';
    static readonly FAN_SPEED_LOW = 'LOW';
    static readonly FAN_SPEED_MED = 'MED';
    static readonly FAN_SPEED_HIGH = 'HIGH';


    // Module Parameters Keys
    static readonly CONTRACTED_POWER_PARAMETER = 'ContractedPower';
    static readonly HVAC_BRAND_PARAMETER = 'Brand';
    static readonly HVAC_ENCODER_PARAMETER = 'Encoder';
    static readonly HVAC_MAX_TEMP_PARAMETER = 'MaxTemp';
    static readonly HVAC_MIN_TEMP_PARAMETER = 'Memp';
    static readonly HVAC_MODEL_PARAMETER = 'Model';
    static readonly STANDBY_POWER_PARAMETER = 'StandbyPower';
    static readonly POWER_CONTROL_PRIORITY_PARAMETER = 'PowerControlPriority';
    static readonly POWER_CONTROL_ENABLED_PARAMETER = 'PowerControlEnabled';
    static readonly POWER_CONTROL_PRESET_PARAMETER = 'PowerControlPreset';
    static readonly BATTERY_SERIALNUMBER_PARAMETER = 'SerialNumber';

    //  MacrosGroup Templates type codenames
    static readonly MACRO_TEMPERATURE_SENSOR = 'NotifyTemperatureReachedimeFrame';
    static readonly MACRO_MOTION_SENSOR = 'NotifyMotionDetectedimeFrame';
    static readonly MACRO_DOOR_WINDOW_SENSOR = 'NotifyDoorWindowOpenedimeFrame';
    static readonly MACRO_SMOKE_SENSOR = 'NotifyIfSmokeIsDetected';
    static readonly MACRO_FLOOD_SENSOR = 'NotifyIfFloodIsDetected';
    static readonly MACRO_POWER_OUTAGE_ALERT = 'AlertInCaseOfDeviceDisconnection';
    static readonly MACRO_BUDGET_CONTROL_ALERT = 'AlertInCaseOfExceededMonthlyBudget';
    static readonly MACRO_FRIDGE_OFF_ALERT = 'AlertInCaseOfFridgeStopsConsuming';
    static readonly MACRO_HIGH_CONSUMPTION_ALERT = 'AlertInCaseOfExcessiveDeviceConsumption';
    static readonly MACRO_OUT_OF_ECONOMIC_ALERT = 'AlertInCaseOfConsumptionOutsideTheEconomicPeriod';
    static readonly MACRO_PRODUCTION_OUTAGE_ALERT = 'AlertInCaseOfSolarProductionAbsence';
    static readonly MACRO_THERMOSTAT = 'ScheduleClimateThermostatimeFrame';


    //  MacrosGroup Templates parameters codenames
    static readonly MACRO_DEVICE_PARAMETER = 'DeviceId';
    static readonly MACRO_DEVICE_MODULE_PARAMETER = 'DeviceModuleId';
    static readonly MACRO_ENERGY_METER_PARAMETER = 'EnergyMeterId';
    static readonly MACRO_ENERGY_METER_ARRAY_PARAMETER = 'EnergyMetersIds';
    static readonly MACRO_MOTION_SENSOR_PARAMETER = 'MotionSensorId';
    static readonly MACRO_DOOR_WINDOW_SENSOR_PARAMETER = 'DoorWindowSensorId';
    static readonly MACRO_SMOKE_SENSOR_PARAMETER = 'DeviceModuleId';
    static readonly MACRO_FLOOD_SENSOR_PARAMETER = 'DeviceModuleId';
    static readonly MACRO_TEMPERATURE_SENSOR_PARAMETER = 'TemperatureSensorId';
    static readonly MACRO_TEMPERATURE_VALUE_PARAMETER = 'TemperatureValue';
    static readonly MACRO_COMPARISON_TYPE_PARAMETER = 'ComparisonType';
    static readonly MACRO_STARTING_HOUR_PARAMETER = 'StartingHour';
    static readonly MACRO_ENDING_HOUR_PARAMETER = 'EndingHour';
    static readonly MACRO_SELECT_DAYS_PARAMETER = 'SelectDays';
    static readonly MACRO_BUDGET_LIMIT_PARAMETER = 'LimitedBudget';
    static readonly MACRO_ANALYSES_PERIOD_PARAMETER = 'AnalyzesPeriod';
    static readonly MACRO_EXCEEDING_VALUE_PARAMETER = 'ExceedingValue';
    static readonly MACRO_SEND_EMAIL_PARAMETER = 'SendEmail';
    static readonly MACRO_USER_ALERT_PARAMETER = 'SendUserAlert';
    static readonly MACRO_THERMOSTAT_PARAMETER = 'ThermostatId';
    static readonly MACRO_MODE_PARAMETER = 'Mode';

    //  MacrosGroup Templates parameters values
    static readonly MACRO_COMPARISON_TYPE_BIGGER = 'Bigger than';
    static readonly MACRO_COMPARISON_TYPE_LOWER = 'Lower than';

    // Cside App ShorCodeNames
    public static ENERGY_CONSUMPTION_APP_CODE = 'EC';
    public static ENERGY_PRODUCTION_APP_CODE = 'EP';
    public static WEATHER_APP_CODE = 'WS';
    public static HOME_AUTOMATION_APP_CODE = 'HA';
    public static EVENT_SCHEDULING_APP_CODE = 'ES';

    // Tariff Name
    public static NORMAL_TARIFF = 'Normal';
    public static ECONOMIC_TARIFF = 'Económico';
    public static SUPERECONOMIC_TARIFF = 'Super económico';

    // Activity Parameters, Return values and Request codes
    static readonly SOURCE_PARAM = 'SOURCE_PARAM';
    static readonly DEVICE_PARAM = 'DEVICE_PARAM';
    static readonly EC_HIST_VARS_PARAM = 'EC_HIST_VARS_PARAM';
    static readonly EC_CURRENT_MONTH_PREDICTION_PARAM = 'EC_CURRENT_MONTH_PREDICTION_PARAM';
    static readonly EP_HIST_VARS_PARAM = 'EP_HIST_VARS_PARAM';
    static readonly MACRO_PARAM = 'MACRO_PARAM';
    static readonly MACROS_GROUP_PARAM = 'MACROS_GROUP_PARAM';
    static readonly GEOFENCE_PARAM = 'GEOFENCE_PARAM';
    static readonly GEOFENCE_ID = 'GEOFENCE_ID';
    static readonly SAVE_ON_EXIT_PARAM = 'SAVE_ON_EXIT_PARAM';
    static readonly MACRO_PARAM_SCHEDULE = 'MACRO_PARAM_SCHEDULE';
    static readonly EDIT_MACRO_INDEX_PARAM = 'EDIT_MACRO_INDEX_PARAM';
    static readonly MODULE_ID_PARAM = 'MODULE_ID_PARAM';
    static readonly MODULE_ID_LIST_PARAM = 'MODULE_ID_LIST_PARAM';
    static readonly SELECTED_PARAM = 'SELECTED_PARAM';
    static readonly EDIT_PROGRAMMING_REQUEST = 109;
    static readonly EDIT_PROGRAMMING_RESULT_DELETE = 2;

    static readonly DAY_CURRENCY_TOTATLIZER_PARAM = 'DAY_CURRENCY_TOTATLIZER_PARAM';
    static readonly DAY_KWH_TOTATLIZER_PARAM = 'DAY_KWH_TOTATLIZER_PARAM';
    static readonly MONTH_CURRENCY_TOTATLIZER_PARAM = 'MONTH_CURRENCY_TOTATLIZER_PARAM';
    static readonly MONTH_KWH_TOTATLIZER_PARAM = 'MONTH_KWH_TOTATLIZER_PARAM';

    static readonly PROFILES_TO_SAVE_PARAM = 'PROFILES_TO_SAVE_PARAM';
    static readonly PROFILES_TO_DELETE_PARAM = 'PROFILES_TO_DELETE_PARAM';
    static readonly PROFILES_LIST_PARAM = 'PROFILES_LIST_PARAM';
    static readonly SHORTCUT_PROFILES_LIST_PARAM = 'SHORTCUT_PROFILES_LIST_PARAM';
    static readonly DEVICE_LIST_PARAM = 'DEVICE_LIST_PARAM';
    static readonly CONSUMPTION_MODULE_PARAM = 'CONSUMPTION_MODULE_PARAM';
    static readonly SUBSCRIBER_PARAM = 'SUBSCRIBER_PARAM';
    static readonly SELF_CONSUMPTION_ENERGY_PARAM = 'SELF_CONSUMPTION_ENERGY_PARAM';
    static readonly MESSAGE_TO_DELETE_PARAM = 'MESSAGE_TO_DELETE_PARAM';

    static readonly SOURCE_ID_PARAM = 'SOURCE_ID_PARAM';
    static readonly CHART_VARIABLE_PARAM = 'CHART_VARIABLE_PARAM';
    static readonly CHART_TYPE_PARAM = 'CHART_TYPE_PARAM';

    static readonly CHART_NAME_PARAM = 'CHART_NAME_PARAM';

    static readonly START_DATE_PARAM = 'START_DATE_PARAM';
    static readonly END_DATE_PARAM = 'END_DATE_PARAM';

    static readonly REQUEST_CODE_GET_MAP_LOCAL = 1;
    static readonly ARG_RADIUS_METERS = 'ARG_RADIUS_METERS';
    static readonly ARG_NEW_LOCATION = 'ARG_NEW_LOCATION';
    static readonly ARG_GEOFENCE_LOCATION = 'ARG_GEOFENCE_LOCATION';
    static readonly RETURN_MAP_LOCATION = 'RETURN_MAP_LOCATION';
}

export enum ClientTariff {
    NORMAL = 'Normal',
    ECONOMIC = 'Economic',
    SUPER_ECONOMIC = 'Super Economic',
    N = 'Normal',
    E = 'Económico',
    SE = 'Super económico',
}

export enum TARIFF_TYPES {
    ELECTRICITY = 'electricity'
};

export enum HomeTypes {
    CELLS_VIEW = 'cells view',
    FLOWS_VIEW = 'flows view'
}
export enum editProfile {
    PROFILE = 'PROFILE',
    HOUSE_PERMISSIONS = 'HOUSE PERMISSIONS',
    PASSWORD = 'PASSWORD'
}

export enum EnergyDetails {
    CONSUMPTION_AND_GENERATION = 'CONSUMPTION AND GENERATION',
    CONSUMPTION = 'CONSUMPTION',
    ELECTRICITY_CONSUMPTION = 'ELECTRICITY CONSUMPTION',
    GAS_CONSUMPTION = 'GAS CONSUMPTION',
    GENERATION = 'GENERATION',
    POWER = 'POWER',
    PREDICTION = 'PREDICTION',
    REPORTS = 'REPORTS'
}

export enum ProfileDetails {
    USERS = 'USERS',
    HOUSE = 'HOUSE',
    SERVICEDETAILS = 'SERVICEDETAILS'
}

export enum EfficiencyDetails {
    EFFICIENCY_TIPS = 'EFFICIENCY TIPS',
    REDY_TIPS = 'REDY TIPS',
    SAVINGS = 'SAVINGS',
    NEIGHBORS_COMPARISON = 'NEIGHBORS COMPARISON',
    ACHIEVEMENTS = 'ACHIEVEMENTS'
}

export enum DeviceMainTypes {
    SENSORS = 'sensors',
    CLIMATIZATION = 'climatization',
    CONSUMPTION = 'consumption',
    GENERATION = 'generation',
}

export enum TutorialTypes {
    VIDEOS_TUTORIALS = 'VIDEOS TUTORIALS',
    DEVICE_MANUALS = 'DEVICE MANUALS'
}

interface DeviceDef {
    order: Number;
    typeInf: Function;
}

export class DeviceMainTypesMap {
    static map = new Map<DeviceMainTypes, DeviceDef>()
        .set(DeviceMainTypes.CONSUMPTION, {
            order: 1,
            typeInf: function (f: Set<string>): boolean {
                return (f.has(Constants.HA_CONSUMPTION_METER) && f.has(Constants.HA_SWITCH) &&
                    !f.has(Constants.HA_SMART_ENERGY_METER));
            }
        })
        .set(DeviceMainTypes.GENERATION, {
            order: 2,
            typeInf: function (f: Set<string>): boolean {
                return (f.has(Constants.HA_PRODUCTION_METER) && !f.has(Constants.HA_SMART_ENERGY_METER));
            }
        })
        .set(DeviceMainTypes.CLIMATIZATION, {
            order: 3,
            typeInf: function (f: Set<string>): boolean {
                return (f.has(Constants.HA_TEMPERATURE_METER) && f.has(Constants.HA_TEMPERATURE_METER) &&
                    !f.has(Constants.HA_SMART_ENERGY_METER));
            }
        })
        .set(DeviceMainTypes.SENSORS, {
            order: 4,
            typeInf: function (f: Set<string>): boolean {
                return f.has(Constants.HS_DETECTOR) && !f.has(Constants.HA_SMART_ENERGY_METER);
            }
        });
}

export class DeviceTypes {
    static map = new Map<string, string>()
        .set('Door & Window', 'HS_DOOR_WINDOW')
        .set('Flood', 'HS_FLOOD')
        .set('Motion', 'HS_MOTION')
        .set('Smoke', 'HS_SMOKE')
        .set('Thermostat', 'HA_THERMOSTAT')
        .set('Air Conditioning', 'HA_HVAC')
        .set('Temperature', 'HA_TEMPERATURE_METER');
}

export enum SchedulingTypes {
    DEVICES = 'devices',
    SPECIALS = 'specials'
}

export enum ScheduleType {
    ON_OFF = 'onoff',
    ECONOMIC = 'Economic',
    SET_POINT = 'Set Point'
}

export enum AlertType {
    ALERT_NO_CONSUMPTION_FRIDGE = 'noConsumptionByFridge',
    ALERT_SIGNIFICANT_CONSUMPTION = 'significantConsumptionIncrease',
    ALERT_DEVICE_DISCONNECTION = 'deviceDisconnection',
    ALERT_NO_PRODUCTION = 'noProduction',
    ALERT_OUT_OF_ECONOMIC = 'consumptionOutsideEconomicPeriod',
    ALERT_BUDGET_CONTROL = 'budgetControl',
    ALERT_EQUIPMENT_LEFT_ON= 'equipmentLeftOnTooLong',
    ALERT_UNUSUAL_WEEK_HOUR_CONSUMPTION = 'unusualWeekHourConsumption'
}

interface AlertDef {
    icon: string;
    name: string;
    description: string;
    hasAlert: Function;
}

export class AlertsMap {
    static map = new Map<AlertType, AlertDef>()
        .set(AlertType.ALERT_BUDGET_CONTROL, {
            icon: 'ic-alerts-budget-control.svg',
            name: 'Budget control',
            // tslint:disable-next-line:max-line-length
            description: 'If the forecast monthly electricity consumption exceeds the monthly budget you have defined, you will be warned from the 5th day of the month. The value to input must include the fixed supply fee, audiovisual licence fee and VAT.',
            hasAlert: function (typeCodeName: string, clientTariff: ClientTariff,
                hasConsDevices: boolean, hasGeneration: boolean, hasSmartMeter: boolean) {
                return (typeCodeName === AlertType.ALERT_BUDGET_CONTROL && hasSmartMeter)
                    || typeCodeName !== AlertType.ALERT_BUDGET_CONTROL;
            }
        })
        .set(AlertType.ALERT_NO_CONSUMPTION_FRIDGE, {
            icon: 'ic-alerts-fridge-off.svg',
            name: 'No fridge consumption',
            // tslint:disable-next-line:max-line-length
            description: 'You will receive an alert if the consumption is null for a period greater than the set in each equipment. This alert does not include power outages.',
            hasAlert: function (typeCodeName: string, clientTariff: ClientTariff,
                hasConsDevices: boolean, hasGeneration: boolean, hasSmartMeter: boolean) {
                return hasConsDevices;
            }
        })
        .set(AlertType.ALERT_SIGNIFICANT_CONSUMPTION, {
            icon: 'ic-alerts-high-consumption.svg',
            name: 'Significative increase in consumption',
            description: 'You will be warned if the average consumption of a device increases by the amount of the defined value.',
            hasAlert: function (typeCodeName: string, clientTariff: ClientTariff,
                hasConsDevices: boolean, hasGeneration: boolean, hasSmartMeter: boolean) {
                return hasConsDevices;
            }
        })
        .set(AlertType.ALERT_OUT_OF_ECONOMIC, {
            icon: 'ic-alerts-out-of-economic.svg',
            name: 'Consumption outside of off-peak period',
            description: 'Be alerted if I am consuming energy from a certain plug when the energy is more expensive.',
            hasAlert: function (typeCodeName: string, clientTariff: ClientTariff,
                hasConsDevices: boolean, hasGeneration: boolean, hasSmartMeter: boolean) {
                return hasConsDevices && (typeCodeName === AlertType.ALERT_OUT_OF_ECONOMIC &&
                    (clientTariff === ClientTariff.ECONOMIC ||
                        clientTariff === ClientTariff.SUPER_ECONOMIC)
                    || (typeCodeName !== AlertType.ALERT_OUT_OF_ECONOMIC));
            }
        })
        .set(AlertType.ALERT_DEVICE_DISCONNECTION, {
            icon: 'ic-alerts-power-outage.svg',
            name: 'Possible power failure',
            description: `If a possible power failure at home and/or internet connection loss occurs you will be warned.`,
            hasAlert: function (typeCodeName: string, clientTariff: ClientTariff,
                hasConsDevices: boolean, hasGeneration: boolean, hasSmartMeter: boolean) {
                return true;
            }
        })
        .set(AlertType.ALERT_NO_PRODUCTION, {
            icon: 'ic-alerts-production-outage.svg',
            name: 'Solar production failure',
            // tslint:disable-next-line:max-line-length
            description: 'If your solar energy system stops producing energy on the last 24 hours, you will be immediately warned. This alert helps you detecting possible anomalies and/or maintenance needs of your photovoltaic system, thus ensuring its maximum efficiency.',
            hasAlert: function (typeCodeName: string, clientTariff: ClientTariff,
                hasConsDevices: boolean, hasGeneration: boolean, hasSmartMeter: boolean) {
                return (typeCodeName === AlertType.ALERT_NO_PRODUCTION && hasGeneration)
                    || typeCodeName !== AlertType.ALERT_NO_PRODUCTION;
            }
        }).set(AlertType.ALERT_EQUIPMENT_LEFT_ON, {
           //  icon: 'ic-alerts-equipment-left-on.svg',
           icon: 'ic-alerts-production-outage.svg',
            name: 'Equipment left on',
            description: '',
            hasAlert: function (typeCodeName: string, clientTariff: ClientTariff,
                hasConsDevices: boolean, hasGeneration: boolean, hasSmartMeter: boolean) {
                return (typeCodeName === AlertType.ALERT_EQUIPMENT_LEFT_ON && hasGeneration)
                    || typeCodeName !== AlertType.ALERT_EQUIPMENT_LEFT_ON;
            }
        }).set(AlertType.ALERT_UNUSUAL_WEEK_HOUR_CONSUMPTION, {
            //  icon: 'ic-alerts-unusual-week-hour-consumption.svg',
            icon: 'ic-alerts-production-outage.svg',
             name: 'Unusual week hour Consumption',
             description: '',
             hasAlert: function (typeCodeName: string, clientTariff: ClientTariff,
                 hasConsDevices: boolean, hasGeneration: boolean, hasSmartMeter: boolean) {
                 return (typeCodeName === AlertType.ALERT_EQUIPMENT_LEFT_ON && hasGeneration)
                     || typeCodeName !== AlertType.ALERT_EQUIPMENT_LEFT_ON;
             }
         });
}

export enum MessageType {
    ALERT = 'ALERT',
    MESSAGE = 'MESSAGE'
}

export enum MessageTab {
    ALL = 'ALL',
    ALERTS = 'ALERTS',
    MESSAGES = 'MESSAGES'
}

export enum ReadOptions {
    MARK_AS_READ = 'Mark as read',
    MARK_AS_UNREAD = 'Mark as unread'
}



// WEBPACK FOOTER //
// ./src/app/shared/constants.ts